<template>
  <div class="right-top-menu" :class="showMenu ? 'width-280' : 'width-0'">
    <div class="menu-content">
      <div style="menu-content-header">
        <langpicker
          v-if="csrfLoaded || null"
          :is-mobile="true"
          class="langpick-mobile"
          @lang-changed="langChanged"
        />

        <div class="float-right">
          <button type="button" class="close" @click="closeMenu">
            <img class="imgmenu" src="@/assets/img/close-light.svg" />
          </button>
        </div>
      </div>

      <div class="menu-content-sec">
        <span class="menu-content-sec1" @click="onClickSaveExit">{{
          getUiText("app-prospect-menu-save-exit-1")
        }}</span>
        <span class="menu-content-sec2" @click="myResponse">{{
          getUiText("app-prospect-menu-review-responses-1")
        }}</span>
        <div class="menu-separation" />
        <div class="menu-content-sec3">
          <div class="menu-context-sec3-item">
            <v-runtime-template :template="createAccountText" />
          </div>
          <div class="menu-context-sec3-item flex-column">
            {{ getUiText("app-prospect-menu-logout-text-1") }}
            <a class="menu-a-tag" href="javascript:void(0)" @click="logout">{{
              getUiText("app-prospect-menu-logout-link-1")
            }}</a>
          </div>
          <div class="menu-separation" />
          <div class="menu-content-sec4">
            <langpicker
              v-if="csrfLoaded || null"
              class="menu-content-sec4-item"
              @lang-changed="langChanged"
            />
          </div>
        </div>
      </div>
      <div class="menu-content-last">
        <img
          class="menu-content-last-img"
          src="@/assets/img/logo-light.svg"
          @click="onClickLogo"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Watch, Prop, Vue } from "vue-facing-decorator";
import LanguagePicker from "@/components/common/languagePicker.vue";
import Utils from "@/utils/utilities";
import VRuntimeTemplate from "vue3-runtime-template";
import store from "@/store";
import { useRoute } from "vue-router";

@Component({
  components: {
    langpicker: LanguagePicker,
    VRuntimeTemplate,
  },
})
export default class ProspectQuestionsMenu extends Vue {
  @Prop({ type: Boolean, required: true })
  public showMenu!: any;
  @Prop({ type: Boolean, required: false, default: true })
  public csrfLoaded!: any;

  private route = useRoute();

  get languageSelected() {
    return store.state.LanguagePicker.languageSelected;
  }
  get defaultUiText() {
    return store.state.LanguagePicker.defaultUiText;
  }
  get languageSelectedText() {
    return store.state.LanguagePicker.languageSelectedText;
  }

  get currentPath() {
    return this.route.path;
  }

  public createAccountTextTags: any = {
    "app-prospect-menu-create-account-link-1": {
      openTag:
        '<a :style="menuAtag" href="javascript:void(0)" @click="createAccount()">',
      closeTag: "</a>",
    },
  };

  public createAccountText = "";

  @Watch("languageSelected")
  onChangeLanguageSelected() {
    setTimeout(() => {
      this.updateUIVariables();
    }, 50);
  }

  get menuAtag() {
    return {
      color: "#ffffff",
      "font-weight": "bold",
      "text-decoration": "underline",
      cursor: "pointer",
    };
  }

  getUiText(id: string, isArray = false) {
    return Utils.getUiText(
      id,
      this.languageSelectedText,
      this.defaultUiText,
      isArray,
    );
  }
  getProcessedUIText(id: string, tags: any) {
    return Utils.getProcessedUIText(
      id,
      tags,
      this.languageSelectedText,
      this.defaultUiText,
    );
  }
  updateUIVariables() {
    this.createAccountText =
      "<span>" +
      this.getProcessedUIText(
        "app-prospect-menu-create-account-1",
        this.createAccountTextTags,
      ) +
      "</span>";
  }
  mounted() {
    this.updateUIVariables();
  }

  closeMenu() {
    this.$emit("closeMenu", {});
  }
  myResponse() {
    this.$emit("myResponse", {});
  }
  createAccount() {
    this.$emit("createAccount", {});
  }
  onClickSaveExit() {
    this.$router.push({ path: "/" });
  }
  onClickLogo() {
    this.$router.push({ path: "/" });
  }
  logout() {
    this.$router.push({ path: "/" });
  }
  langChanged() {
    if (
      this.currentPath === "/prospect/questions" ||
      this.currentPath === "/prospect/responses"
    ) {
      this.$router.go(0);
    }
  }
}
</script>

<style lang="scss" scoped>
.right-top-menu {
  top: 0px;
  width: 280px;
  background: #0345bd;
  box-shadow: inset 0px 2px 4px rgba(33, 31, 88, 0.15);
  position: fixed;
  height: 100%;
  overflow-x: hidden;
  -webkit-transition: right 0.5s ease;
  -moz-transition: right 0.5s ease;
  -o-transition: right 0.5s ease;
  -ms-transition: right 0.5s ease;
  transition: right 0.5s ease;
  z-index: 1060;
}
.menu-content {
  margin-top: 50.4px;
}

.menu-content-header {
  display: unset;
}

.close {
  color: #211f58;
  opacity: 1 !important;
  padding-right: 41px;
}
.imgmenu {
  width: 19.09px;
  height: 19.09px;
}
.menu-content-sec {
  display: inline-grid;
  margin-top: 56.45px;
}

.menu-content-sec1 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  color: #ffffff;
  padding-right: 41px;
  cursor: pointer;
}

.menu-content-sec2 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  color: #ffffff;
  margin-top: 47px;
  padding-right: 41px;
  cursor: pointer;
}

.menu-content-sec3 {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  margin-top: unset !important;
  position: relative;
  color: #ffffff;
  padding-right: 41px;
  padding-left: 28px;
}

.menu-context-sec3-item {
  margin-top: 60px;
}

.menu-content-sec4 {
  display: flex;
  justify-content: flex-end;
}

.menu-content-sec4-item {
  margin-top: 60px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}
.menu-a-tag {
  color: #ffffff;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
.menu-content-last {
  bottom: 0px;
  position: absolute;
  padding-bottom: 41.5px;
  right: 45px;
  float: right;
}
.menu-content-last-img {
  width: 123px;
  height: 27.53px;
}
.menu-separation {
  border-bottom: 1px solid #ffffff;
  padding-top: 50px;
  opacity: 0.1;
}
.width-280 {
  right: 0px;
}
.width-0 {
  right: -100%;
}
.langpick-mobile {
  display: none;
  width: 145px;
}

@media screen and (max-width: 767px), screen and (max-height: 699px) {
  .langpick-mobile {
    display: block;
    float: left;
  }
  .menu-content-sec4 {
    display: none;
  }
  .menu-content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .menu-content-sec3 {
    padding-left: 16px;
  }
}

@media (min-width: 3840px) {
  .right-top-menu {
    width: 480px !important;
    background: #0345bd;
    box-shadow: inset 0px 4px 8px rgba(33, 31, 88, 0.15);
  }
  .menu-content {
    margin-top: 100.8px;
  }

  .close {
    color: #211f58;
    opacity: 1 !important;
    padding-right: 41px;
  }
  .imgmenu {
    width: 38.09px;
    height: 38.09px;
  }
  .menu-content-sec {
    display: inline-grid;
    margin-top: 113.45px;
  }

  .menu-content-sec1 {
    font-size: 28px;
    line-height: 48px;
    padding-right: 81px;
    cursor: pointer;
  }

  .menu-content-sec2 {
    font-size: 28px;
    line-height: 42px;
    margin-top: 94px;
    padding-right: 81px;
    cursor: pointer;
  }

  .menu-content-sec3 {
    font-size: 24px;
    line-height: 42px;
    text-align: right;
    padding-right: 81px;
  }
  .menu-context-sec3-item {
    margin-top: 120px;
  }

  .menu-content-sec4-item {
    margin-top: 120px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .menu-content-last {
    padding-bottom: 82.5px;
    right: 90px;
  }
  .menu-content-last-img {
    width: 246px;
    height: 55.53px;
  }
  .menu-separation {
    border-bottom: 2px solid #ffffff;
    padding-top: 100px;
    opacity: 0.1;
  }
}
</style>
